import { formatFreshness } from "../../../utils/directorFormat";

const labels = {
  portfolio_mapping_changed: "Mapeamento financeiro alterado",
  opening_balance_changed: "Saldo inicial alterado",
  resource_alias_decided: "Equivalência de recurso decidida",
};

const GovernanceHistory = ({ items = [] }) => <section className="governance-section" aria-labelledby="history-title">
  <header><div><span className="director-eyebrow">Rastreabilidade</span><h2 id="history-title">Histórico de governança</h2></div></header>
  {items.length === 0 ? <p>Nenhuma alteração registrada.</p> : <ol className="governance-history">
    {items.map((item) => <li key={item._id || item.requestId}>
      <div><strong>{labels[item.action] || item.action}</strong><span>{formatFreshness(item.createdAt)} · ator {item.actorId}</span></div>
      <p>{item.reason}</p>
      {item.sourceNote && <small>Fonte: {item.sourceNote}</small>}
    </li>)}
  </ol>}
</section>;

export default GovernanceHistory;
